// cache-plugin.js
export default {
  install(Vue, options = {}) {
    const prefix = options.prefix || "pdv_";
    const vuex = options.vuex || null;

    const getKey = (key) => prefix + key;

    const now = () => Math.floor(Date.now() / 1000);

    const cache = {

      /**
       * Salva item no cache
       * @param {string} key
       * @param {any} value
       * @param {number|null} ttlSegundos
       */
      set(key, value, ttlSegundos = 3600) {
        const expiresAt = ttlSegundos ? now() + ttlSegundos : null;

        const payload = {
          value,
          expiresAt
        };

        localStorage.setItem(getKey(key), JSON.stringify(payload));
      },

      /**
       * Lê item do cache — retorna null se expirado ou inválido
       */
      get(key, fallback = null) {
        try {
          const item = localStorage.getItem(getKey(key));
          if (!item) return fallback;

          const payload = JSON.parse(item);

          // expiração
          if (payload.expiresAt && now() > payload.expiresAt) {
            this.remove(key);
            return fallback;
          }

          return payload.value;

        } catch (e) {
          console.error("Erro lendo cache:", key, e);
          return fallback;
        }
      },

      /**
       * Verifica se expirou sem deletar
       */
      isExpired(key) {
        try {
          const item = localStorage.getItem(getKey(key));
          if (!item) return true;

          const payload = JSON.parse(item);

          if (!payload.expiresAt) return false;

          return now() > payload.expiresAt;

        } catch {
          return true;
        }
      },

      /**
       * Remove apenas 1 chave
       */
      remove(key) {
        localStorage.removeItem(getKey(key));
      },

      /**
       * Remove todas as chaves prefixadas
       */
      resetAll() {
        Object.keys(localStorage)
          .filter(k => k.startsWith(prefix))
          .forEach(k => localStorage.removeItem(k));
      },

      /**
       * Carrega tudo do cache para o Vuex (somente valores válidos)
       */
      loadToVuex() {
        if (!vuex || !options.mapVuex) return;

        const map = options.mapVuex;

        Object.keys(map).forEach(key => {
          const mutation = map[key];
          const value = this.get(key);

          if (value !== null && value !== undefined) {
            vuex.commit(mutation, value);
          }
        });
      }
    };

    Vue.prototype.$cache = cache;

    // autoload opcional
    if (options.autoload) {
      cache.loadToVuex();
    }
  }
};
